'use client';

import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

interface TrustIndicator {
  id: number;
  icon: string;
  value: string;
  labelKey: string;
}

export default function TrustIndicators() {
  const { t } = useLanguage();
  
  const mockTrustIndicators: TrustIndicator[] = [
    {
      id: 1,
      icon: 'CalendarIcon',
      value: '9+',
      labelKey: 'home.trust.years'
    },
    {
      id: 2,
      icon: 'UserGroupIcon',
      value: '500+',
      labelKey: 'home.trust.partners'
    },
    {
      id: 3,
      icon: 'TruckIcon',
      value: '10K+',
      labelKey: 'home.trust.deliveries'
    },
    {
      id: 4,
      icon: 'ShieldCheckIcon',
      value: '100%',
      labelKey: 'home.trust.guaranteed'
    }
  ];

  return (
    <section data-component-id="src/app/homepage/components/TrustIndicators.tsx:44:4" data-component-path="src/app/homepage/components/TrustIndicators.tsx" data-component-line="44" data-component-file="TrustIndicators.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20bg-primary%20text-primary-foreground%22%7D" className="py-16 bg-primary text-primary-foreground">
      <div data-component-id="src/app/homepage/components/TrustIndicators.tsx:45:6" data-component-path="src/app/homepage/components/TrustIndicators.tsx" data-component-line="45" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-6%20lg%3Apx-12%22%7D" className="container mx-auto px-6 lg:px-12">
        <div data-component-id="src/app/homepage/components/TrustIndicators.tsx:46:8" data-component-path="src/app/homepage/components/TrustIndicators.tsx" data-component-line="46" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20lg%3Agrid-cols-4%20gap-8%22%7D" className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {mockTrustIndicators.map((indicator) => (
            <div data-component-id="src/app/homepage/components/TrustIndicators.tsx:48:12" data-component-path="src/app/homepage/components/TrustIndicators.tsx" data-component-line="48" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%22%7D" key={indicator.id} className="text-center">
              <div data-component-id="src/app/homepage/components/TrustIndicators.tsx:49:14" data-component-path="src/app/homepage/components/TrustIndicators.tsx" data-component-line="49" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mb-4%22%7D" className="flex justify-center mb-4">
                <div data-component-id="src/app/homepage/components/TrustIndicators.tsx:50:16" data-component-path="src/app/homepage/components/TrustIndicators.tsx" data-component-line="50" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-16%20h-16%20bg-accent%20rounded-full%20flex%20items-center%20justify-center%22%7D" className="w-16 h-16 bg-accent rounded-full flex items-center justify-center">
                  <Icon data-component-id="src/app/homepage/components/TrustIndicators.tsx:51:18" data-component-path="src/app/homepage/components/TrustIndicators.tsx" data-component-line="51" data-component-file="TrustIndicators.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-accent-foreground%22%7D" name={indicator.icon as any} size={32} className="text-accent-foreground" />
                </div>
              </div>
              <div data-component-id="src/app/homepage/components/TrustIndicators.tsx:54:14" data-component-path="src/app/homepage/components/TrustIndicators.tsx" data-component-line="54" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-4xl%20lg%3Atext-5xl%20font-heading%20font-bold%20mb-2%22%7D" className="text-4xl lg:text-5xl font-heading font-bold mb-2">
                {indicator.value}
              </div>
              <div data-component-id="src/app/homepage/components/TrustIndicators.tsx:57:14" data-component-path="src/app/homepage/components/TrustIndicators.tsx" data-component-line="57" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-lg%20opacity-90%22%7D" className="text-lg opacity-90">
                {t(indicator.labelKey)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}